import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MailCheck } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { BrandMarkDark } from "../components/BrandMark";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault(); setErr(""); setLoading(true);
        try { await api.post("/auth/forgot-password", { email }); setSent(true); }
        catch (ex) { setErr(formatApiError(ex.response?.data?.detail) || "Odeslání selhalo"); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <div className="w-full max-w-md bg-white border border-slate-200 sharp-shadow p-8" data-testid="forgot-password-page">
                <div className="mb-8"><BrandMarkDark /></div>
                <div className="label-eyebrow mb-2">Obnova hesla</div>
                <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mb-6">Zapomenuté heslo</h1>
                {sent ? (
                    <div className="space-y-4" data-testid="forgot-sent">
                        <div className="flex items-start gap-3 border-l-4 border-emerald-600 bg-emerald-50 px-4 py-3 text-sm text-slate-800"><MailCheck className="w-5 h-5 text-emerald-700 shrink-0" /><div>Pokud účet <b>{email}</b> existuje, poslali jsme na něj e-mail s odkazem pro nastavení nového hesla. Odkaz platí 1 hodinu. Zkontrolujte i složku spam.</div></div>
                        <Link to="/prihlaseni" className="text-sm font-semibold text-orange-600 hover:underline">Zpět na přihlášení</Link>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5">
                        <p className="text-sm text-slate-600">Zadejte e-mail svého účtu, pošleme vám odkaz pro nastavení nového hesla.</p>
                        <div>
                            <label className="label-eyebrow block mb-2">Email</label>
                            <input type="email" inputMode="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"
                                   className="w-full px-4 py-3 border border-slate-300 bg-white text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 focus:border-transparent rounded-sm" placeholder="vas@email.cz" />
                        </div>
                        {err && <div className="border-l-4 border-red-600 bg-red-50 px-4 py-2 text-sm text-red-700" data-testid="forgot-error">{err}</div>}
                        <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 font-semibold uppercase tracking-wider text-sm disabled:opacity-50 rounded-sm">
                            {loading ? "Odesílám…" : "Poslat odkaz"} <ArrowRight className="w-4 h-4" />
                        </button>
                        <Link to="/prihlaseni" className="block text-sm font-semibold text-orange-600 hover:underline">Zpět na přihlášení</Link>
                    </form>
                )}
            </div>
        </div>
    );
}
